import React from "react";
import Modal from "components/base/Modal";
import css from "../style.scss";
import dailyCalGoalLeft from "assets/images/niceWork.svg";
import CloseBlack from "assets/images/CloseBlack.svg";
import CheckboxItem from "components/Checkbox";

const NiceWorkModal = ({ isOpen, onClose, isDoNotShowAgainChecked, onDoNotShowAgainCheck }) => {
    return (
        <Modal
            isOpen={isOpen}
            isCloseButton={false}
            uniqId="BatchDialerModal"
            width="auto"
            borderRadius="12px"
            modalClassName={css.NiceWorkModal}
            onClose={onClose}
        >
            <div className={css.modalWrapper}>
                <div className={css.imageSection}>
                    <img src={dailyCalGoalLeft} alt="nice work" />
                    <div className={css.closeBtn} onClick={onClose}>
                        <img src={CloseBlack} alt="close" />
                    </div>
                </div>
                <div className={css.contentSection}>
                    <h2>Nice work — you’re on a roll 👏</h2>
                    <div className={css.group18}>
                        <p>
                            You’ve completed <span className={css.highlight}>135 call attempts</span>{" "}
                            today - <span className={css.subCount}>15</span> more to go before today’s cap.
                        </p>

                        <p className={css.subHeading}>Need higher volume?</p>

                        <p style={{fontSize: "18px"}}>
                            BatchDialer adds multi-line dialing + more <br /> capacity.
                        </p>
                    </div>

                    <div className={css.group29}>
                        <div className={css.buttonRow}>
                            <button className={css.secondaryBtn} onClick={onClose}>
                                Keep calling
                            </button>

                            <button
                                className={css.primaryBtn}
                                onClick={() =>
                                    window.open("https://batchdialer.com/click2dial", "_blank", "noopener,noreferrer")
                                }
                            >
                                Upgrade to BatchDialer
                            </button>
                        </div>

                        <div className={css.checkboxRow}>
                            <CheckboxItem
                                checked={isDoNotShowAgainChecked}
                                onChange={(event) => onDoNotShowAgainCheck?.(event.target.checked)}
                                boxClassName={css.smallBox}
                                checkmarkClassName={css.smallCheckmark}
                            />
                            <span className={css.checkboxLabel}>Do not show again</span>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default NiceWorkModal;